// import React from "react";
// import "../trending.css";
// function Trendingcurrentaffairs() {

//   return (
//     <div>
//       <div className="hader">
//         <span className="left">Trending Current Affairs</span>
//         <span className="right">Explore More</span>
//       </div>
//       <div className="news">
//         {imageData.map((news, index) => (
//           <div className="news-card" key={index}>
//             <img
//               src={news.images[0].image_url}
//               alt={news.topic}
//               className="news-image"
//             />
//             <div className="news-content">
//               <p className="news-title">{news.topic}</p>
//               <a className="news-source" href={news.source} target="_blank" rel="noopener noreferrer">
//                 Sources ↗
//               </a>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }
// export default Trendingcurrentaffairs;

// import React, { useEffect, useState } from "react";
// import "../trending.css";
// import { fetchTrendingData } from "../services/trendingService";

// function Trendingcurrentaffairs() {
//   const [imageData, setImageData] = useState([]);

//   useEffect(() => {
//     fetchTrendingData()
//       .then((data) => setImageData(data))
//       .catch((error) => console.error("Error loading data:", error));
//   }, []);

//   return (
//     <div>
//       <div className="hader">
//         <span className="left">Trending Current Affairs</span>
//         <span className="right">Explore More</span>
//       </div>
//       <div className="news">
//         {imageData.map((news, index) => (
//           <div className="news-card" key={index}>
//             <img
//               src={news.images[0].image_url}
//               alt={news.topic}
//               className="news-image"
//             />
//             <div className="news-content">
//               <p className="news-title">{news.topic}</p>
//               <a className="news-source" href={news.source} target="_blank" rel="noopener noreferrer">
//                 Sources ↗
//               </a>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default Trendingcurrentaffairs;

import React, { useEffect, useState } from "react";
import "../currentaffarcard.css";
import { fetchTrendingData } from "../services/trendingService";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import Currentaffairscard from "./CurrentAffairsCard";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
function Trendingcurrentaffairs() {
  // const [imageData, setImageData] = useState([]);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);
  // const navigate = useNavigate();

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await fetchTrendingData();
  //       setImageData(response.items || []);
  //       setLoading(false);
  //     } catch (err) {
  //       setError(err.message || 'Failed to fetch trending data');
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  // if (loading) {
  //   return <div>Loading...</div>;
  // }

  // if (error) {
  //   return <div>Error: {error}</div>;
  // }

  // return (
  //   <div>
  //     <div className="hader">
  //       <span className="left">Trending Current Affairs</span>
  //       <span className="right">Explore More</span>
  //     </div>

  //     <div className="news">
  //       {imageData.map((news, index) =>
  //         news.images && news.images.length > 0 && news.images[0].image_url ? (
  //           <div className="news-card" key={index}>
  //             <img
  //               src={news.images[0].image_url}
  //               alt={news.topic}
  //               className="news-image"
  //             />
  //             <div className="news-content">
  //               <p className="news-title">{news.topic}</p>
  //               {news.source && (
  //                 <div
  //                   style={{ cursor: "pointer" }}
  //                   className="news-source"
  //                   onClick={() => navigate('/CurrentAffairs', { state: { id: news.id } })}
  //                   rel="noopener noreferrer"
  //                 >
  //                   Sources ↗
  //                 </div>
  //               )}
  //             </div>
  //           </div>
  //         ) : (
  //           <div className="news-card" key={index}>
  //             <div className="news-content">
  //               <p className="news-title">{news.topic}</p>
  //               <p className="news-text">
  //                 {news.content ? news.content.split(" ").slice(0, 8).join(" ") + "..." : ""}
  //               </p>
  //               {news.source && (
  //                 <div
  //                   className="news-source"
  //                   style={{ cursor: "pointer" }}
  //                   onClick={() => navigate(`/CurrentAffairs/${news.id}`)}
  //                 >
  //                   Sources ↗
  //                 </div>
  //               )}
  //             </div>
  //           </div>
  //         )
  //       )}
  //     </div>
  //   </div>
  // );

  const [imageData, setImageData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const CACHE_KEY = "trending_current_affairs_cache";

  const readCache = () => {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed.items) ? parsed : null;
    } catch {
      return null;
    }
  };

  const writeCache = (items) => {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ items }));
    } catch {
      // ignore storage errors (e.g. quota exceeded)
    }
  };

  const itemsSignature = (items) => {
    try {
      return JSON.stringify(items.map((item) => item.id));
    } catch {
      return "";
    }
  };

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      const cached = readCache();
      if (cached && cached.items.length > 0) {
        setImageData(cached.items);
        setLoading(false);
      } else {
        setLoading(true);
      }

      try {
        const response = await fetchTrendingData();
        if (cancelled) return;
        const freshItems = response.items || [];

        if (cached && cached.items.length > 0) {
          if (itemsSignature(cached.items) !== itemsSignature(freshItems)) {
            setImageData(freshItems);
            writeCache(freshItems);
          }
        } else {
          setImageData(freshItems);
          writeCache(freshItems);
        }
        setLoading(false);
      } catch (err) {
        if (cancelled) return;
        setError(err.message || "Failed to fetch trending data");
        setLoading(false);
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, []);

  // if (loading)
  //   return (
  //     <div className="main-div-load" >
  //       <div className="child-div-load" >
  //         <Skeleton height={100} style={{ marginBottom: "15px" }} />
  //         <Skeleton height={40} style={{ marginBottom: "15px" }} />
  //         <Skeleton count={4} />
  //       </div>
  //        <div className="child-div-load"  >
  //         <Skeleton height={100}  />
  //         <Skeleton height={40} style={{ marginBottom: "15px" }} />
  //         <Skeleton count={4} />
  //       </div>
  //       <div className="child-div-load"  >
  //         <Skeleton height={100} style={{ marginBottom: "15px" }} />
  //         <Skeleton height={40} style={{ marginBottom: "15px" }} />
  //         <Skeleton count={4} />
  //       </div>
  //        <div className="child-div-load"  >
  //         <Skeleton height={100} style={{ marginBottom: "15px" }} />
  //         <Skeleton height={40} style={{ marginBottom: "15px" }} />
  //         <Skeleton count={4} />
  //       </div>
  //     </div>
  //   );

  return (
    <div>
      <div className="hader">
        <span className="left">🔥Trending Current Affairs</span>
        <span
          className="right"
          onClick={() => navigate("/currentaffairs")}
        >
          More <ChevronRight size={15} strokeWidth={2.5} aria-hidden="true" />
        </span>
      </div>

      <div className="news custm-news trendi">
        {imageData.map((news, index) => (
          <Currentaffairscard key={index} news={news} />
        ))}
      </div>
      {loading && (
        <div className="main-div-load">
  {[...Array(4)].map((_, index) => (
    <div className="child-div-load" key={index}>
      <div>
    <Skeleton height={30} style={{ marginBottom: "6px" }} />
<Skeleton height={14} style={{ marginBottom: "6px" }} />
<Skeleton count={3} height={6} style={{ marginBottom: "4px" }} />

      </div>
    </div>
  ))}
</div>
      )}
    </div>
  );
}

export default Trendingcurrentaffairs;

// thicsdibjb
